
/**
 * Marker Template
 * @param {obj} data - property data/json
 */
function markerTmpl(data) {

  const url = encodeURIComponent(data.address)

  return `
    <div class="row store-wrapper d-flex align-items-center my-2 my-md-4 p-2 p-md-4">
        <div class="col-12 col-md-8 text-start">
            <h4 class="marker-box__title">${data.title}</h4>
            <div class="marker-box__description">${data.description}</div>
            <p class="marker-box__cta">
                <a href="${data.cta}" target="${data.ctatarget}" title="${data.ctaname}">${data.ctaname}</a>
            </p>
        </div>
        <div class="col-12 col-md-3 offset-0 offset-md-1">
            <img src="${data.logo}" alt="${data.title}" class="img-fluid" style="max-width: 100%!important;"/>
        </div>
    </div>
  `;
}

export default markerTmpl;
